export const AddressTypesTranslation = {
  C: 'sales_orders:ADDRESS_typeConfirmation',
  D: 'sales_orders:ADDRESS_typeDelivery',
  S: 'sales_orders:ADDRESS_typeShipTo',
  I: 'sales_orders:ADDRESS_typeInvoice',
  P: 'sales_orders:ADDRESS_typeDebtor',
};
